import styles from "../../pages/Community/CreateCommunityPage.module.css";
import placeholderImage from "../../assets/images/image-upload-placeholder.png";

const ImageUploadField = ({
  label,
  imageUrl,
  onUpload,
  onDelete,
  isSubmitting,
}) => (
  <div className={styles.imageSectionWrapper}>
    <label className={styles.inlineLabel}>{label}</label>
    <div className={styles.featuredImageBox}>
      {imageUrl ? (
        <>
          <img src={imageUrl} alt={label} className={styles.featuredImageBox} />
          <button
            type="button"
            onClick={onDelete}
            className={styles.removeImageButton}
            disabled={isSubmitting}
            title="Remove image"
          >
            ✕
          </button>
        </>
      ) : (
        <div className={styles.iconPlaceholderContainer}>
          <img
            src={placeholderImage}
            alt="Placeholder"
            className={styles.iconPlaceholder}
          />
          <div className={styles.uploadLinks}>
            <label className={styles.uploadLink}>
              <span className={styles.plusIcon}>+</span> Choose {label}
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={onUpload}
                disabled={isSubmitting}
              />
            </label>
          </div>
        </div>
      )}
    </div>
  </div>
);

const CommunityContent = ({ content, setContent, isSubmitting, title }) => {
  const handleContentBannerWebUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setContent((prev) => ({
      ...prev,
      contentBannerWebFile: file,
      contentBannerWebUrl: URL.createObjectURL(file),
      deleteContentBannerWeb: false,
    }));
  };

  const handleContentBannerAppUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setContent((prev) => ({
      ...prev,
      contentBannerAppFile: file,
      contentBannerAppUrl: URL.createObjectURL(file),
      deleteContentBannerApp: false,
    }));
  };

  const handleContentImageWebUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setContent((prev) => ({
      ...prev,
      contentImageWebFile: file,
      contentImageWebUrl: URL.createObjectURL(file),
      deleteContentImageWeb: false,
    }));
  };

  const handleContentImageAppUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setContent((prev) => ({
      ...prev,
      contentImageAppFile: file,
      contentImageAppUrl: URL.createObjectURL(file),
      deleteContentImageApp: false,
    }));
  };

  const deleteContentBannerWeb = () => {
    setContent((prev) => ({
      ...prev,
      contentBannerWebFile: null,
      contentBannerWebUrl: "",
      deleteContentBannerWeb: true,
    }));
  };

  const deleteContentBannerApp = () => {
    setContent((prev) => ({
      ...prev,
      contentBannerAppFile: null,
      contentBannerAppUrl: "",
      deleteContentBannerApp: true,
    }));
  };

  const deleteContentImageWeb = () => {
    setContent((prev) => ({
      ...prev,
      contentImageWebFile: null,
      contentImageWebUrl: "",
      deleteContentImageWeb: true,
    }));
  };

  const deleteContentImageApp = () => {
    setContent((prev) => ({
      ...prev,
      contentImageAppFile: null,
      contentImageAppUrl: "",
      deleteContentImageApp: true,
    }));
  };

  return (
    <>
      <label className={styles.inlineLabel}>Community Content (Optional)</label>

      {/* Academy Title */}
      <div className={styles.rowInputGroup}>
        <label className={styles.inlineLabel}>{title || "Academy Title"}</label>
        <input
          type="text"
          value={content.communityTitle}
          onChange={(e) =>
            setContent({ ...content, communityTitle: e.target.value })
          }
          className={styles.textInput}
          disabled={isSubmitting}
        />
      </div>

      {/* Content Banner Web */}
      <ImageUploadField
        label="Content Banner (Website)"
        imageUrl={content.contentBannerWebUrl}
        onUpload={handleContentBannerWebUpload}
        onDelete={deleteContentBannerWeb}
        isSubmitting={isSubmitting}
      />

      {/* Content Banner App */}
      <ImageUploadField
        label="Content Banner (Mobile App)"
        imageUrl={content.contentBannerAppUrl}
        onUpload={handleContentBannerAppUpload}
        onDelete={deleteContentBannerApp}
        isSubmitting={isSubmitting}
      />

      {/* Content Title */}
      <div className={styles.rowInputGroup}>
        <label className={styles.inlineLabel}>Content Title</label>
        <input
          type="text"
          value={content.contentTitle}
          onChange={(e) =>
            setContent({ ...content, contentTitle: e.target.value })
          }
          className={styles.textInput}
          disabled={isSubmitting}
        />
      </div>

      {/* Primary Text */}
      <div className={styles.rowInputGroup}>
        <label className={styles.inlineLabel}>Primary Text</label>
        <textarea
          name="body_text"
          value={content.primaryText}
          onChange={(e) =>
            setContent({ ...content, primaryText: e.target.value })
          }
          className={styles.textAreaLarge}
          rows="4"
          placeholder="Use **text** for bold formatting"
          disabled={isSubmitting}
        />
      </div>
      <span className={styles.hint}>Tip: Use **text** to make text bold</span>

      {/* Content Image Web */}
      <ImageUploadField
        label="Content Image (Website)"
        imageUrl={content.contentImageWebUrl}
        onUpload={handleContentImageWebUpload}
        onDelete={deleteContentImageWeb}
        isSubmitting={isSubmitting}
      />

      {/* Content Image App */}
      <ImageUploadField
        label="Content Image (Mobile App)"
        imageUrl={content.contentImageAppUrl}
        onUpload={handleContentImageAppUpload}
        onDelete={deleteContentImageApp}
        isSubmitting={isSubmitting}
      />

      {/* Secondary Text */}
      <div className={styles.rowInputGroup}>
        <label className={styles.inlineLabel}>Secondary Text</label>
        <textarea
          name="body_text"
          value={content.secondaryText}
          onChange={(e) =>
            setContent({ ...content, secondaryText: e.target.value })
          }
          className={styles.textAreaLarge}
          rows="4"
          placeholder="Use **text** for bold formatting"
          disabled={isSubmitting}
        />
      </div>
      <span className={styles.hint}>Tip: Use **text** to make text bold</span>
    </>
  );
};

export default CommunityContent;
